document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.delivery-date_conn');
  if (!el) return;

  const startDays = +el.dataset.startDays;
  const endDays   = +el.dataset.endDays;
  const output    = el.querySelector('.delivery-date_value');

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const key = `delivery_${today.toISOString().slice(0,10)}_${startDays}_${endDays}`;

  const saved = localStorage.getItem(key);
  if (saved) {
    output.textContent = saved;
    return;
  }

  const startDate = new Date(today);
  startDate.setDate(today.getDate() + startDays);

  const endDate = new Date(today);
  endDate.setDate(today.getDate() + endDays);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };

  const text = `${formatDate(startDate)} – ${formatDate(endDate)}`;

  localStorage.setItem(key, text);
  output.textContent = text;
});


// ============================= show seleceted vainats value accoding to options ================================
document.addEventListener('DOMContentLoaded', () => {
  const variantBlocks = document.querySelectorAll('[data-js-product-variant]');
  if (!variantBlocks.length) return;
  variantBlocks.forEach(block => {
    const valueEl = block.querySelector('.product-variant__name-value');
    const inputs  = block.querySelectorAll('.product-variant__input');

    if (!valueEl || !inputs.length) return;

    const updateValue = () => {
      const checked = block.querySelector('.product-variant__input:checked');
      if (checked) {
        valueEl.textContent = checked.value;
      }
    };

    // ✅ Initial value on load
    updateValue();

    // ✅ Update on change
    inputs.forEach(input => {
      input.addEventListener('change', updateValue);
    });
  });
});

// ============================= show seleceted vainats value accoding to options ================================
